module.exports = __webpack_public_path__ + "img/Girl_010019.31e35fde.png";